import { excludeKeys } from '@repo/common-utils';
import { useUserEventLogger } from '@repo/tracking-service';
import { BoxButton, Description, Divider, MainTitle, StickyBottomWrapper, TextList } from '@repo/ui';
import { useRouter } from 'next/router';
import { useState } from 'react';

import { RefundAvailabilityAlarmButton } from './RefundAvailabilityAlarmButton';

import { useSectionScrollModel } from '@/components/common/context/SectionScrollModelProvider';
import { LookupResultAdDrawer } from '@/components/tax-refund/lookup/result/LookupResultAdDrawer';
import { useLookupResultRefundData } from '@/components/tax-refund/lookup/result/LookupResultContext';
import { COMMON_PATHS } from '@/lib/constants/paths';

export const UnderRefundContent = () => {
  const router = useRouter();
  const { refundAmount, businessType } = useLookupResultRefundData();

  const [isDrawerShow, setIsDrawerShow] = useState(false);

  const cutoffDate = new Date('2025-10-12T20:30:00');
  const isAfterCutoff = new Date() >= cutoffDate;

  const { eventAttribute } = useSectionScrollModel();
  const { pageName, sendClickEvent, sendViewEvent } = useUserEventLogger();

  sendViewEvent(`${pageName}_result`, { ...excludeKeys(eventAttribute ?? {}, ['current_section']), amount: refundAmount, grade: 'shortage' });

  const handleClick = () => {
    sendClickEvent(`${pageName}_result-unable`, { amount: refundAmount });
    router.push({
      pathname: `${COMMON_PATHS.환급조회목록}`,
      query: router.query
    });
  };

  return (
    <>
      <div className="page-padding">
        <Description
          title={'환급 신청이 어려워요...'}
          description="아쉽게도 환급액이 신청 금액 기준에 맞지 않아 환급 신청이 어려워요."
          button={<RefundAvailabilityAlarmButton />}
        />
        <Divider />
        <div className={'py-normal-small'}>
          <MainTitle title={'비즈넵 환급의 신청 금액 기준'} size="xsmall" />
          {businessType === 'indis' ? (
            <>
              <TextList className={'text-gray-700'} size={'medium'}>
                {isAfterCutoff
                  ? '종합소득세 환급은 세액 감면 항목에 따라 최소 10만원에서 50만원 이상이어야 신청 가능해요.'
                  : '종합소득세 환급은 현재 환급 신청이 매우 많아, 100만원 이상인 경우에 한해 신청이 가능해요.'}
              </TextList>
              <TextList className={'text-gray-700'}>양도소득세 환급은 10만원 이상이어야 신청 가능해요.</TextList>
            </>
          ) : (
            <TextList className={'text-gray-700'} size={'medium'}>
              법인세 환급은 30만원 이상이어야 신청 가능해요.
            </TextList>
          )}
        </div>
        <StickyBottomWrapper supportText={'신규 환급금이 생기면 알려드릴게요!'}>
          <BoxButton size={'large'} className={'w-full'} variant={'tonal-secondary'} onClick={handleClick}>
            확인
          </BoxButton>
        </StickyBottomWrapper>
      </div>

      <LookupResultAdDrawer
        open={isDrawerShow}
        onOpenChange={setIsDrawerShow}
        delay={2500}
        businessType={businessType}
        eventAttributes={{ amount: refundAmount }}
      />
    </>
  );
};

export default UnderRefundContent;
